export function isEditableTarget(target: EventTarget | null): boolean {
	if (!(target instanceof HTMLElement)) return false
	if (target.isContentEditable) return true

	const tagName = target.tagName
	if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT") {
		return true
	}

	return target.closest("[contenteditable='true']") !== null
}
